<template>
    <div>
        <kendo-datetimepicker
            :ref="'datepicker' + uid"
            v-model="dateValue"
            @change="inputChanged"
            :format="customFormat"
            :time-format="timeFormat"
            :name="'datetimepicker' + uid"
            v-validate="required ? 'required' : ''"
            style="width: 100%;"
            :start="datepickerStart"
            :depth="datepickerDepth"
            :disabled="readonly"
            :min="dateMinVal"
            :max="dateMaxVal"
            :data-vv-as="fieldName"
            :interval="5"
        ></kendo-datetimepicker>
        <span class="text-danger col-12" v-if="errors.has('datetimepicker' + uid)">{{ errors.first('datetimepicker' + uid) }}</span>
    </div>
</template>

<script>
    export default {
        inject: ['$validator'],
        props: {
            value: [Date, String],
            required: {
                type: Boolean,
                default: false
            },
            format: {
                type: String
            },
            timeFormat: {
                type: String,
                default: 'HH:mm'
            },
            showTime: {
                type: [Boolean, String],
                default: true
            },
            readonly: {
                type: Boolean,
                default: false
            },
            min: {
                type: [Date, String],
                required: false
            },
            max: {
                type: [Date, String],
                required: false
            },
            showOnlyYear: {
                type: Boolean,
                default: false
            },
            fieldName: String,
            convertToLocalTime: {
                type: Boolean,
                default: true
            },
            useUtcTime: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                uid: Math.floor(Math.random() * 0x10000).toString(16),
                dateValue: '',
                changedFromPicker: false,
                defaultDateMinVal: new Date(1900, 0, 1),
                defaultDateMaxVal: new Date(2159, 0, 1),
                customFormat: ''
            };
        },
        methods: {
            inputChanged(event) {
                this.changedFromPicker = true;
                if (event.sender.value()) {
                    if (this.useUtcTime) {
                        this.$emit('input', event.sender.value().toUTCString());
                    } else {
                        this.$emit('input', event.sender.value());
                    }
                } else {
                    this.$emit('input', event.sender.value());
                }
            },
            convertFromUtcToLocal() {
                if (this.value) {
                    let dateUtc = new Date(this.value);
                    if (dateUtc && (dateUtc.getTimezoneOffset() > 0 || dateUtc.getTimezoneOffset() < 0)) {
                        this.dateValue = new Date(
                            Date.UTC(
                                dateUtc.getFullYear(),
                                dateUtc.getMonth(),
                                dateUtc.getDate(),
                                dateUtc.getHours(),
                                dateUtc.getMinutes(),
                                dateUtc.getSeconds()
                            )
                        );
                    } else {
                        this.dateValue = dateUtc;
                    }
                }
            }
        },
        watch: {
            value: {
                immediate: true,
                handler(newVal, oldVal) {
                    // let dt = this.$refs['' + this.uid];
                    // if (dt) {
                    //    dt.kendoWidget().trigger("change");
                    // }

                    if (this.changedFromPicker) {
                        this.changedFromPicker = false;
                        return;
                    }

                    if (newVal) {
                        if (this.convertToLocalTime) {
                            this.convertFromUtcToLocal();
                        } else {
                            if (this.value) {
                                if (this.value instanceof (Date)) {
                                    this.dateValue = this.value;
                                } else {
                                    this.dateValue = new Date(this.value);
                                }
                            }
                        }
                    } else {
                        this.dateValue = this.value;
                    }
                }
            }
        },
        computed: {
            // Трябва да се направи така понеже ако подадем new Date() слага сегашния час
            // и прави интервалите от по 5 минути от него нататък
            dateMinVal() {
                var d = this.min || this.defaultDateMinVal;
                return new Date(d.getFullYear(), d.getMonth(), d.getDate());
            },
            dateMaxVal() {
                var d = this.max || this.defaultDateMaxVal;
                return new Date(d.getFullYear(), d.getMonth(), d.getDate());
            },
            datepickerStart() {
                return this.showOnlyYear ? 'decade' : 'month'; // mounth is default value
            },
            datepickerDepth() {
                return this.showOnlyYear ? 'decade' : '';
            }
        },
        mounted() {
            kendo.culture('bg-BG');

            // const dp = this.$refs[`datepicker${this.uid}`].kendoWidget();
            // if (dp) {
            //	let options = dp.options;
            //	options.parseFormats = [
            //		...dp.options.parseFormats,
            //		'yyyy',
            //		'dd.MM.yyyy',
            //		'dd.MM.yyyy HH:mm',
            //		'dd.MM.yyyy HH:mm:ss',
            //		'dd.MM.yyyy tt',
            //		'dd.MM.yyyy HH:mm tt',
            //		'dd.MM.yyyy HH:mm:ss tt',
            //		kendo.culture().calendar.patterns['d']
            //	];
            //	dp.setOptions(options);

            //	options = dp.options;
            // }

            if (!this.format) {
                if (this.showOnlyYear) {
                    this.customFormat = 'yyyy';
                } else {
                    if (!this.showTime) {
                        this.customFormat = 'dd.MM.yyyy';
                    } else {
                        this.customFormat = 'dd.MM.yyyy HH:mm';
                    }
                }
            } else {
                this.customFormat = this.format;
            }

            if (this.convertToLocalTime) {
                this.convertFromUtcToLocal();
            } else {
                if (this.value) {
                    if (this.value instanceof (Date)) {
                        this.dateValue = this.value;
                    } else {
                        this.dateValue = new Date(this.value);
                    }
                }
            }
        }
    };
</script>
